import { render, staticRenderFns } from "./Gdp.vue?vue&type=template&id=080d9d22"
import script from "./Gdp.vue?vue&type=script&lang=js"
export * from "./Gdp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports